import { useMemo } from "react";
import { ClipLoader } from "react-spinners";

interface Props {
  color?: string;
  size?: string | number;
  speedMultiplier?: number;
  borderWidth?: number | string;
}

export default function Loading({
  color = "var(--interactive)",
  size,
  speedMultiplier = 0.5,
  borderWidth: borderWidthProp,
}: Props) {
  const borderWidth = useMemo(() => {
    if (borderWidthProp) {
      return borderWidthProp;
    }
    // depending on the size we want to set the border width
    if (!size) {
      return 4;
    }
    const sizeNumber = Number(size);
    if (sizeNumber < 10) {
      return 2;
    }
    if (sizeNumber < 20) {
      return 4;
    }
    if (sizeNumber < 30) {
      return 6;
    }
    return 8;
  }, [borderWidthProp, size]);

  return (
    <ClipLoader
      color={color}
      speedMultiplier={speedMultiplier}
      size={size}
      cssOverride={{
        borderWidth,
      }}
    />
  );
}
